import * as React from "react";
const LogoutIconSvg = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.41602 6.29983C7.67435 3.29983 9.21602 2.07483 12.591 2.07483H12.6993C16.4243 2.07483 17.916 3.5665 17.916 7.2915V12.7248C17.916 16.4498 16.4243 17.9415 12.6993 17.9415H12.591C9.24102 17.9415 7.69935 16.7332 7.42435 13.7832"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66406 9.99988H12.3974"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.541 7.20825L13.3327 9.99992L10.541 12.7916"
      stroke="#404548"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default LogoutIconSvg;
